export default __webpack_public_path__ + "static/media/NEWlogo-preto.c5055f53.png";